import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { authService } from '../../../services/AuthenticationService';
import { routes } from '../../../route-list';
import { VerifyEmailScreen } from '../components/VerifyEmailScreen';

export const VerifyEmailContainer: React.FC = () => {
  const history = useHistory();
  const location = useLocation<{ email?: string }>();
  const email = location.state?.email;

  const onBackToLogin = () => {
    authService.logout();
    history.replace(routes.LOGIN);
  };

  return <VerifyEmailScreen email={email} onBackToLogin={onBackToLogin} />;
};
